export default __webpack_public_path__ + "static/media/mediaTwoImageOne.d55a54b2.jpeg";